import BaseAPIService from '@/services/baseAPIService'

export default class ProductionAPIService extends BaseAPIService {
  constructor(httpClient, reportingHttpClient) {
    super(httpClient, reportingHttpClient)
  }

  // Toughening Batches
  getTougheningBatch(id)                                { return this.httpClient.get(`/production/tougheningbatches/${id}`) }

  // Stages
  getProductionStageList()                              { return this.httpClient.get(`/production/stages`) }
  getProductionStage(id)                                { return this.httpClient.get(`/production/stages/${id}`) }
  createProductionStage(data)                           { return this.httpClient.post(`/production/stages`, data) }
  updateProductionStage(id, data)                       { return this.httpClient.put(`/production/stages/${id}`, data) }
  updateProductionStageBatch(listData)                  { return this.httpClient.put(`/production/stages`, listData) }
  archiveProductionStage(id)                            { return this.httpClient.put(`/production/stages/${id}/archive`) }
  restoreProductionStage(id)                            { return this.httpClient.put(`/production/stages/${id}/restore`) }

  // Stations
  getProductionStationList()                            { return this.httpClient.get(`/production/stations`) }
  getProductionStation(id)                              { return this.httpClient.get(`/production/stations/${id}`) }
  createProductionStation(data)                         { return this.httpClient.post(`/production/stations`, data) }
  updateProductionStation(id, data)                     { return this.httpClient.put(`/production/stations/${id}`, data) }
  updateProductionStationFinances(id, data)             { return this.httpClient.put(`/production/stations/${id}/finances`, data) }
  updateProductionStationHardware(id, data)             { return this.httpClient.put(`/production/stations/${id}/hardware`, data) }
  updateProductionStationMaintenance(id, data)          { return this.httpClient.put(`/production/stations/${id}/maintenance`, data) }
  archiveProductionStation(id)                          { return this.httpClient.put(`/production/stations/${id}/archive`) }
  restoreProductionStation(id)                          { return this.httpClient.put(`/production/stations/${id}/restore`) }

  // Stock Links
  getStockProductionConfig(stockId)                     { return this.httpClient.get(`/production/stock/${stockId}/config`) }
  updateStockProductionConfig(stockId, data)            { return this.httpClient.put(`/production/stock/${stockId}/config`, data) }

  // Production Panels
  getProductionPanelList(params = {}) {
    return this.httpClient.get(`/production/panels?${$.param(params)}`)
  }
  getProductionPanel(id)                                { return this.httpClient.get(`/production/panels/${id}`) }

  // Production - Config Settings
  getConfigSettings()                                   { return this.httpClient.get(`/production/configuration/settings`) }
  updateConfigSettings(data)                            { return this.httpClient.put(`/production/configuration/settings`, data) }

  // Production - Manager
  getProductionManagerSummary()                         { return this.httpClient.get(`/production/manager/summary`) }
  routeProductionPanel(data)                            { return this.httpClient.post(`/production/manager/routepanel`, data) }

}
